import CustomDateRangePicker from '../../../../Dispatch/DispatchChat/MessageHistory/components/CustomDateRangePicker';
import { withStyles } from '@material-ui/core';
import WithRowLabel from '../../../../Dispatch/RouteExecution/Pickups/PickupManagement/components/WithRowLabel';

const styles = (theme) => ({
  inputField: {
    padding: 0,
    height: 32,
    fontSize: theme.textFontSize,
    color: theme.TextColor,
    paddingLeft: 8,
    paddingRight: 8
  },
  inputRoot: {
    '& $notchedOutline,$inputMultiline': {
      padding: 0,
      height: 'auto'
    },
    '&$inputDisabled': {
      // padding: 8,
    }
  },
  inputDisabled: {},
  inputMultiline: {}
});

const StyledCustomDateRangePicker = withStyles(styles)(CustomDateRangePicker);
const CustomDateRangePickerWithLabel = WithRowLabel(StyledCustomDateRangePicker);
export { StyledCustomDateRangePicker, CustomDateRangePickerWithLabel };
